import Collection from './generic/collection';
import { onAjaxContentLoaded } from "./generic/evented";

class ModelViewer {
  constructor(instance) {
    this.instance = instance;
    this.init();
  }

  init() {
    const config = this.parseConfig(this.instance.getAttribute("data-js-3d-model"));
    const modelViewer = ModelViewerCollection.createModelViewer(config);

    // Вставляем <model-viewer> в контейнер
    this.instance.appendChild(modelViewer);
  }

  parseConfig(configString) {
    try {
      return JSON.parse(configString);
    } catch (error) {
      console.error("Ошибка парсинга конфигурации:", error);
      return {};
    }
  }
}

export class ModelViewerCollection extends Collection {
  static selectors = {
    instance: '[data-js-3d-model]',
  };

  constructor() {
    super(ModelViewerCollection.selectors.instance, ModelViewer);
    this.loadModelViewerScript().then(() => {
      this.init();
      this.bindEvents();
    });
  }

  static createModelViewer({
    src,
    autoRotate = true,
    cameraControls = true,
    backgroundColor = '#ffffff',
    width = '100%',
    height = '400px',
    disableZoom = false
  }) {
    const modelViewer = document.createElement('model-viewer');

    modelViewer.src = src;
    modelViewer.setAttribute('background-color', backgroundColor);

    if (autoRotate) {
      modelViewer.setAttribute('auto-rotate', true);
    }
    if (cameraControls) {
      modelViewer.setAttribute('camera-controls', true);
    }
    if (disableZoom) {
      modelViewer.setAttribute('disable-zoom', true);
    }

    modelViewer.style.width = width;
    modelViewer.style.height = height;

    return modelViewer;
  }

  // Функция для динамической загрузки скрипта Model Viewer
  loadModelViewerScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "module";
      script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";

      script.onload = () => {
        console.debug("Model Viewer library loaded");
        resolve();
      };

      script.onerror = () => {
        console.error("Failed to load Model Viewer library");
        reject();
      };

      document.head.appendChild(script);
    });
  }

  //TODO: мб имеет смысл на onAjaxContentLoaded инициалзицию прикрутить, потому что будет динамическая пагинация, будут добавляться новые ноды и на них надо будет делать viewer
  init() {
    $(ModelViewerCollection.selectors.instance).each((index, el) => {
      new ModelViewer(el);
    });
  }

  bindEvents () {
    onAjaxContentLoaded(() => {
      this.init()
    })
  }
}
